import { NavLink, useLocation } from 'react-router-dom';
import React, { useContext, useMemo } from 'react';
import { CurrentUserContentSettingsContext } from '../../../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/CurrentUserContentSettingsProvider';
import PopUpMenu from '../../../../../../kingpin/atoms/PopUpMenu';
import LeftNavItem from '../../../Common/LeftNavItem';
import Typography from '../../../../../../kingpin/atoms/Typography';
import Icon from '../../../../../../kingpin/atoms/Icon';
import NavMenuPopup from './NavMenuPopup';
import useMappedViewMetaData from './useMappedViewMetaData';
import PopUpMenuChevron from './PopUpMenuChevron';

const ViewItem = ({
  navItem,
  product,
  app,
}: {
  entity: EntityDetails.Entity;
  entityApp: EntityDetails.App;
  app: V3.ProductApp;
  product: V3.Product;
  navItem: V3.Navigation.MappedEntityView;
}) => {
  const link = useMemo(() => {
    return `/views/${app.urlSlug}/${navItem.key}`;
  }, [app.urlSlug, navItem.key]);

  if (!link) {
    return null;
  }

  return (
    <NavLink to={link}>
      <NavMenuPopup.ItemProductDiv>
        <Icon
          icon={product.icon}
          width={24}
          height={24}
          color={'var(--color-icon-primary)'}
        />
        <Typography.Body type={'Label 14'}>{navItem.label}</Typography.Body>
      </NavMenuPopup.ItemProductDiv>
    </NavLink>
  );
};

const ViewItemProvider = ({
  view,
}: {
  view: UserManagement.EngagementContentMapping;
}) => {
  const metaData = useMappedViewMetaData(view);

  if (!metaData) {
    return null;
  }

  return <ViewItem {...metaData} />;
};

const ViewsMenuPopup = ({
  mappings,
}: {
  mappings: UserManagement.EngagementContentMapping[];
}) => {
  return (
    <NavMenuPopup.PopupDiv>
      {mappings.map((view) => (
        <ViewItemProvider key={view.entityId} view={view} />
      ))}
    </NavMenuPopup.PopupDiv>
  );
};

const ViewsMenu = ({
  mappings,
}: {
  mappings: UserManagement.EngagementContentMapping[];
}) => {
  const { pathname } = useLocation();
  const isSelected = useMemo(() => {
    return pathname.includes('/views/');
  }, [pathname]);

  return (
    <PopUpMenu
      trigger={({ isOpen }: { isOpen: boolean }) => (
        <LeftNavItem isOpen={isOpen || isSelected}>
          <Typography.Body type={'Label 14'}>Views</Typography.Body>
          <PopUpMenuChevron isOpen={isOpen} />
        </LeftNavItem>
      )}
      children={() => <ViewsMenuPopup mappings={mappings} />}
      position={'bottom-start'}
    />
  );
};

const Gate = () => {
  const { contentSettings } = useContext(CurrentUserContentSettingsContext);

  if (
    contentSettings.mode === 'normal' ||
    contentSettings.mappings.length === 0
  ) {
    return null;
  }

  return <ViewsMenu mappings={contentSettings.mappings} />;
};

export default Gate;
